<template>
  <label class="checkbox">
    <input
      :id="`checkbox_${id}`"
      type="checkbox"
      :class="{ 'checked': value}"
      class="styled-checkbox"
      v-model="value"
      @change="emitChange"
    >
    <label
      :for="`checkbox_${id}`"
      v-html="`&nbsp;${label}`"
    />
    <!--input
      type="checkbox"
      v-model="value"
      @change="emitChange"
    >&nbsp;
    <span
      v-html="label"
    /-->
  </label>
</template>

<script>

const randId = () => {
  return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1)
}

export default {
  name: 'Checkbox',
  data () {
    return {
      id: randId(),
      value: false
    }
  },
  props: {
    initialValue: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    extraClass: {
      type: String,
      default: ''
    },
    label: {
      type: [Boolean, String],
      default: false
    },
    message: {
      type: [Boolean, Object],
      default: false
    }
  },
  mounted () {
    this.value = this.initialValue
  },
  watch: {
    initialValue () {
      this.value = this.initialValue
    }
  },
  methods: {
    emitChange () {
      this.$emit('changedValue', this.value)
    }
  }
}
</script>
